<template>
    <Signup />
</template>

<script>
import Signup from '@/components/redeem/Signup.vue';

export default {
    components: {
        Signup,
    },
    created() {

    },
};
</script>
